import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'

var BackgroundOption = BootslideMenu.WidgetMultipleChoiceOption.extend({
	property: 'tablePadding'
})

function createMenu (model) {
	var options = _.map(['small', 'medium', 'large'], function (type) {
		return {
			label: type,
			contentView: BackgroundOption.extend({ value: type, label: i18n.get('dashboards.tablePadding.' + type) }),
			model: model
		}
	})

	return {
		type: 'submenu',
		label: 'dashboards.tablePadding',
		target: options
	}
}

export default createMenu

createMenu.__filename__ = 'dashboards/widgets/wob-table-padding-menu.js'
